import React from 'react';
import { Helmet } from 'react-helmet-async';

// Import favicon and social image (update paths as needed)
import favicon from '../assets/Navbar/New logo.png';
import socialImage from '../assets/Navbar/New logo.png'; // Replace with a 1200x630px social media image if available

// Default SEO props for reusability
const defaultProps = {
    title: 'Sun Flower Beach Resort - Luxury Retreat in Beruwala, Sri Lanka',
    description:
        'Discover Sun Flower Beach Resort in Beruwala, Sri Lanka, offering luxurious accommodations, authentic Ayurvedic wellness treatments, gourmet dining, and beachfront relaxation. Book your serene coastal getaway today!',
    keywords:
        'beach resort, luxury resort, ayurveda wellness, spa, restaurant, Beruwala, Sri Lanka, Sun Flower Beach Resort, vacation, relaxation, holistic healing, yoga, meditation, detox, rejuvenation, health, wellbeing, ayurvedic treatments, panchakarma, abhyanga, beachfront, coastal getaway, fine dining, organic cuisine, sustainable tourism, tropical escape, family vacation, couples retreat, wellness retreat, stress relief, nature, eco-friendly resort, sri lanka travel, beruwala resort, luxury accommodations',
    url: 'https://sunflower-resort.com/',
    image: socialImage,
    type: 'website',
};

// Structured data for Hotel
const getStructuredData = ({ title, description, url, image }) => [
    {
        '@context': 'https://schema.org',
        '@type': 'Hotel',
        name: 'Sun Flower Beach Resort',
        description: description,
        url: url,
        image: image,
        telephone: '+94 77 534 0670',
        address: {
            '@type': 'PostalAddress',
            streetAddress: '6th Lane, Police Bungalow Rd',
            addressLocality: 'Beruwala',
            addressRegion: 'Western Province',
            postalCode: '12070',
            addressCountry: 'LK',
        },
        geo: {
            '@type': 'GeoCoordinates',
            latitude: '6.4741',
            longitude: '79.9903',
        },
        openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday',
            ],
            opens: '08:00',
            closes: '20:00',
        },
        priceRange: '$30-$100',
        starRating: {
            '@type': 'Rating',
            ratingValue: '4.7',
            bestRating: '5',
        },
        amenityFeature: [
            {
                '@type': 'LocationFeatureSpecification',
                name: 'Ayurveda Wellness Spa',
                value: true,
            },
            {
                '@type': 'LocationFeatureSpecification',
                name: 'Beachfront Access',
                value: true,
            },
            {
                '@type': 'LocationFeatureSpecification',
                name: 'Restaurant',
                value: true,
            },
            {
                '@type': 'LocationFeatureSpecification',
                name: 'Luxury Accommodations',
                value: true,
            },
        ],
    },
    {
        '@context': 'https://schema.org',
        '@type': 'Restaurant',
        name: 'Sun Flower Beach Resort Restaurant',
        description: 'Enjoy gourmet dining with organic, locally sourced cuisine at Sun Flower Beach Resort’s restaurant, offering a blend of Sri Lankan and international flavors with beachfront views.',
        url: `${url}/restaurant`,
        image: image,
        telephone: '+94 77 534 0670',
        address: {
            '@type': 'PostalAddress',
            streetAddress: '6th Lane, Police Bungalow Rd',
            addressLocality: 'Beruwala',
            addressRegion: 'Western Province',
            postalCode: '12070',
            addressCountry: 'LK',
        },
        servesCuisine: ['Sri Lankan', 'International'],
        priceRange: '$10-$40',
    },
];

const SEO = ({
    title = defaultProps.title,
    description = defaultProps.description,
    keywords = defaultProps.keywords,
    url = defaultProps.url,
    image = defaultProps.image,
    type = defaultProps.type,
}) => {
    const structuredData = getStructuredData({ title, description, url, image });

    return (
        <Helmet>
            <meta charset="utf-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#12392B" />
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Sun Flower Beach Resort" />
            <meta name="robots" content="index, follow" />
            <title>{title}</title>
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="Sun Flower Beach Resort" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <link rel="icon" href={favicon} />
            <link rel="apple-touch-icon" href={favicon} />
            <link rel="manifest" href="/manifest.json" />
            <link rel="canonical" href={url} />
            <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
        </Helmet>
    );
};

export default SEO;